<template>
  <section class="barocare-b2c-home">
    <div class="popup-wrapper" >
      <div class="popup" v-intersect>
        <barocare-b2c-apply-popup />
      </div>
    </div>
    <div class="img-area">
      <img src="../../assets/pc_barocare_b2c/home.jpg" alt="">
    </div>      
    <div class="title-area" >
      <h2 class="title" v-intersect>집에서 진료 보고<br>약 배송 받아보세요</h2>
      <p class="sub-text" v-intersect>가장 쉽고 편리한 의료서비스<br>바로돌봄이 여러분의 건강을 지켜드리겠습니다.</p>
    </div>
    <div class="btn-area">
      <a href="http://pf.kakao.com/_xhcxkQG/friend" target="_blank" title="새창" class="btn-medical" v-intersect>진료 예약 바로가기</a>
    </div>
    <div class="fixed-btn-area">
      <a href="http://pf.kakao.com/_xhcxkQG/friend" target="_blank" title="새창" class="btn-chat">채팅상담 바로가기</a>
    </div>
  </section>
</template>

<script>
import BarocareB2cApplyPopup from '@/components/pc_barocare_b2c/BarocareB2cApplyPopup.vue';

export default {
  name: 'BarocareB2cHome',
  components: {
    BarocareB2cApplyPopup
  },
  directives: {
    intersect: {
      // 요소가 DOM에 삽입될 때 호출됩니다.
      inserted(el) {
        const options = {
          root: null, // 뷰포트를 기본값으로 설정
          rootMargin: '0px', // 뷰포트의 마진은 0
          threshold: 0.1 // 10%가 보일 때 콜백이 실행
        };
        const callback = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.classList.add('visible');
            } else {
              el.classList.remove('visible');
            }
          });
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(el); // 해당 요소를 관찰 시작
      }
    }
  },
};
</script>

<style scoped>
    .popup-wrapper {
        width: 1200px;
        position: absolute;
        left: 50%;
        height: 301px;
        top: 310px;
        transform: translate(-50%, 0);
        z-index: 10;
    }
    .popup {
        width: 328px;
        height: 301px;
        position: absolute;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-radius: 20px;
        background: #E5F0FC;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        flex-direction: column;
        padding: 20px 24px 23px 22px;
        z-index: 0;
        top: 0;
        right:0;
    }

</style>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_b2c/BarocareB2cHome.vue